<template>
    <div>
        <div class="list-item" v-for="(item, index) in list" :key="index">
            <div class="item-name">
                <!--一级目录-->
                <div v-if=" item.attributes.operateType == 1 && item.attributes.componentType == 1 " class="title">{{item.text}}</div>

                <!--需填写内容 -->
                <div v-else-if=" item.attributes.operateType == 9 && item.attributes.componentType == 7" class="content">
                    
                    <div v-for="(subItem, subIndex) in item.attributes.content.config" :key="subIndex">
                        
                        <!-- 标签-->
                        <div v-if="subItem.inputType == 'label'" style="margin-top:5px;font-weight:bold;">
                            {{subItem.inputValue}}
                        </div>
                        <!-- 多行文本-->
                        <div v-else-if="subItem.inputType == 'textarea'">
                            <el-input
                                type="textarea"
                                :placeholder="subItem.placeholder"
                                :maxlength="subItem.limit"
                                show-word-limit>
                            </el-input>
                        </div>
                        
                        <!-- 图片，视频,附件-->
                        <div v-else-if="subItem.inputType.indexOf('image')>-1  && subItem.inputType.indexOf('video')>-1 
                            &&  subItem.inputType.indexOf('file')>-1" style="border:1px solid red;">
                             该区域是图片与视频+附件上传入口（不支持），可在小程序端查看。
                        </div>
                        <!-- 图片，视频-->
                        <div v-else-if="subItem.inputType.indexOf('image')>-1 
                            &&  subItem.inputType.indexOf('video')>-1" style="border:1px solid red;">
                             该区域是图片与视频上传入口（不支持），可在小程序端查看。
                        </div>
                        <!-- 图片，附件-->
                        <div v-else-if="subItem.inputType.indexOf('image')>-1 
                            &&  subItem.inputType.indexOf('file')>-1" style="border:1px solid red;">
                             该区域是图片与附件上传入口（不支持），可在小程序端查看。
                        </div>
                        <!-- 视频,附件-->
                        <div v-else-if="subItem.inputType.indexOf('video')>-1 
                            &&  subItem.inputType.indexOf('file')>-1" style="border:1px solid red;">
                             该区域是视频与附件上传入口（不支持），可在小程序端查看。
                        </div>
                        <!-- 图片-->
                        <div v-else-if="subItem.inputType.indexOf('image')>-1" style="border:1px solid red;">
                             该区域是图片上传入口（不支持），可在小程序端查看。
                        </div>
                        <!-- 视频-->
                        <div v-else-if="subItem.inputType.indexOf('video')>-1" style="border:1px solid red;">
                             该区域是视频上传入口（不支持），可在小程序端查看。
                        </div>

                        <!-- 单行文本框-->
                        <div v-else-if="subItem.inputType == 'input'">
                            <el-input
                                type="text"
                                :placeholder="subItem.placeholder"
                                :maxlength="subItem.limit"
                                show-word-limit>
                            </el-input>
                        </div>
                        <!-- 下拉选择框-->
                        <div v-else-if="subItem.inputType == 'select'">
                            <el-select :placeholder="subItem.placeholder" clearable style="width:100%">
                                <el-option
                                    v-for="item in subItem.data"
                                    :key="item.key"
                                    :label="item.label"
                                    :value="item.key">
                                </el-option>
                            </el-select>
                        </div>
                        <!-- 日期选择器-->
                        <div v-else-if="subItem.inputType == 'date'">
                            <el-date-picker  style="width:100%"
                                type="date"
                                :placeholder="subItem.placeholder">
                            </el-date-picker>
                        </div>
                        <!-- 签名-->
                        <div v-else-if="subItem.inputType == 'qm'" style="border:1px solid red;">
                            该区域是签名入口（不支持），可在小程序端查看。
                        </div>
                        <!-- text文本框-->
                        <div v-else-if="subItem.inputType == 'text'">
                            {{subItem.inputValue==""?"未填写":subItem.inputValue}}
                        </div>
                        
                    </div>
                </div>

                <!--一级目录以下目录展示-->
                <div v-else-if=" item.attributes.operateType != 1 && item.attributes.componentType == 1 ">{{item.text}}</div>


            </div>
            <div v-if="item.children" class="children-item">
                <list :list="item.children"></list>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "List",
        props: {
            list: Array
        }
    };
</script>
<style scoped>
    .title {
        background: #2B6695;
        border-radius: 6px 6px 6px 6px;
        box-shadow: 0 0 0 1px #5F5A4B, 1px 1px 6px 1px rgba(10, 10, 0, 0.5);
        color: #FFFFFF;
        font-family:"微软雅黑", "宋体", "黑体", Arial;
        font-size: 18px;
        font-weight: bold;
        height: 25px;
        line-height: 25px;
        margin: 18px 0 !important;
        padding: 8px 0 5px 5px;
        text-shadow: 2px 2px 3px #222222;
    }

    .content {
        overflow-y: hidden;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/teacher/config/TreeCollapse.vue